import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { ROUTES } from '../../constants/routes';

const AccessDenied = ({ className }) => {
  const navigate = useNavigate();

  return (
    <div className={className}>
      <Alert variant="danger" className="mt-4">
        You do not have permission to view this page.
      </Alert>
      <Button variant="secondary" className="mt-3" onClick={() => navigate(ROUTES.SEARCH)}>
        Back to Search
      </Button>
    </div>
  );
};

export default AccessDenied;
